import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=1ac58f00&"
import script from "./TodoList.vue?vue&type=script&lang=ts&"
export * from "./TodoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports